import React from "react";
import { createRoot } from "react-dom/client";
import AttendeeDocumentWorkspace from "./AttendeeDocumentWorkspace";

const ROOT_ID = "attendee-document-workspace-root";

const mount = () => {
  if (document.getElementById(ROOT_ID)) return;
  const container = document.createElement("div");
  container.id = ROOT_ID;
  document.body.appendChild(container);
  createRoot(container).render(<AttendeeDocumentWorkspace />);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount, { once: true });
} else {
  mount();
}
